import type { AiDraft, AiLanguage } from "@/api";

/**
 * Panel tili → AI javob tili. `uz-Latn`, `ru-RU` kabi kodlar ham tanilsin;
 * noma'lum til — o'zbekcha (platformaning asosiy tili).
 */
export const aiLanguage = (language: string | undefined): AiLanguage => {
  const base = language?.toLowerCase().split("-")[0];
  return base === "ru" || base === "en" ? base : "uz";
};

/** Fon vazifasi hali tugamagan — natija kelguncha so'rab turiladi. */
export const isDraftPending = (draft: Pick<AiDraft, "status"> | null | undefined): boolean =>
  draft?.status === "QUEUED" || draft?.status === "RUNNING";
